var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 31.5V8.75L36.75 5.25V28",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 36.75C13.3995 36.75 15.75 34.3995 15.75 31.5C15.75 28.6005 13.3995 26.25 10.5 26.25C7.60051 26.25 5.25 28.6005 5.25 31.5C5.25 34.3995 7.60051 36.75 10.5 36.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.25C34.3995 33.25 36.75 30.8995 36.75 28C36.75 25.1005 34.3995 22.75 31.5 22.75C28.6005 22.75 26.25 25.1005 26.25 28C26.25 30.8995 28.6005 33.25 31.5 33.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusics);
export default __webpack_public_path__ + "static/media/musics.505914103a47317297fe5d6befb76ec8.svg";
export { ForwardRef as ReactComponent };